import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { FieldsApiService } from 'features/fields';
import i18n from 'locales/i18n';
import { queryClient } from 'providers';

import { fieldsQueryKeys } from './query-keys';

const { deleteTimeRange } = FieldsApiService();

export const useDeleteTimeRange = () => {
  const { message } = App.useApp();

  return useMutation(
    (id: string) => {
      return deleteTimeRange(id);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        console.error(uiMessage);
        message.error(i18n.t('fields.update.errorTimeRangeDelete'));
      },
      onSuccess: (_, id) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: fieldsQueryKeys.lists(),
          }),
          queryClient.invalidateQueries({
            queryKey: fieldsQueryKeys.detail(id),
          }),
        ]);
        message.success(i18n.t('fields.update.successfulTimeRangeDelete'));
      },
    },
  );
};
